import TableCell from './TableCell';
import { withStyles } from '@material-ui/core/styles';

export default withStyles({
  root: {
    backgroundColor: '#C6C6C6',
  },
})(TableCell);
